export const STATUSES = {
  DRAFT: 'DRAFT',
  ACTIVE_NO_TICKETS_SOLD: 'ACTIVE_NO_TICKETS_SOLD',
  ACTIVE_TICKETS_SOLD: 'ACTIVE_TICKETS_SOLD',
  CLOSED: 'CLOSED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
}

export const STATUS_LABELS = {
  [STATUSES.DRAFT]: 'Draft',
  [STATUSES.ACTIVE_NO_TICKETS_SOLD]: 'Active · no tickets',
  [STATUSES.ACTIVE_TICKETS_SOLD]: 'Active · selling',
  [STATUSES.CLOSED]: 'Closed',
  [STATUSES.COMPLETED]: 'Completed',
  [STATUSES.CANCELLED]: 'Cancelled',
}

export const STATUS_COLORS = {
  [STATUSES.DRAFT]: 'default',
  [STATUSES.ACTIVE_NO_TICKETS_SOLD]: 'gold',
  [STATUSES.ACTIVE_TICKETS_SOLD]: 'green',
  [STATUSES.CLOSED]: 'blue',
  [STATUSES.COMPLETED]: 'geekblue',
  [STATUSES.CANCELLED]: 'red',
}

export const FILTER_STATUS_OPTIONS = [
  { label: 'Draft', value: 'DRAFT' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Closed', value: 'CLOSED' },
  { label: 'Archived', value: 'ARCHIVED' },
]

export const ACTIVE_STATUSES = [
  STATUSES.ACTIVE_NO_TICKETS_SOLD,
  STATUSES.ACTIVE_TICKETS_SOLD,
]

export const TERMINAL_STATUSES = [STATUSES.COMPLETED, STATUSES.CANCELLED]

export const CANCELLABLE_STATUSES = [
  STATUSES.DRAFT,
  STATUSES.ACTIVE_NO_TICKETS_SOLD,
]

export const EDITABLE_STATUSES = [
  STATUSES.DRAFT,
  STATUSES.ACTIVE_NO_TICKETS_SOLD,
  STATUSES.ACTIVE_TICKETS_SOLD,
]

export const FORM_MODAL_ID = 'surpriseBoxPromotionForm'
export const DETAILS_MODAL_ID = 'surpriseBoxPromotionDetails'

export const SURPRISE_BOX_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss'
